import axios from "../../config/axiosConfig";
import { WORKER_AVERAGE_SUCCESS, WORKER_AVERAGE_REQUEST, WORKER_AVERAGE_REQUEST_FAILURE, SET_PRODUCTION_TRANSACTION_ID,
  SET_WORKER_AVERAGE_SUMMURY } from "../types";

export const getWorkerAverageByTransactionId = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_AVERAGE_REQUEST });
      const { auth } = getState();
      let params = {
        customerId: auth?.user?.Customer_Id,
        companyId: auth.company?.id,
        finyearId: auth.finyear?.id,
    };
      return axios.get(`/worker-average/get-by-trans-id/${id}`, { params }).then((response) => {
        if (response.data) {
            dispatch({ type: SET_PRODUCTION_TRANSACTION_ID, payload: id });
            dispatch({ type: WORKER_AVERAGE_SUCCESS, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_AVERAGE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_AVERAGE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const clearWorkerAverages = () => {
  return async (dispatch, getState) => {
    dispatch({ type: SET_PRODUCTION_TRANSACTION_ID, payload: null });
    dispatch({ type: WORKER_AVERAGE_SUCCESS, payload: [] });
  }
}

export const getWorkerAverageSummary = (machineId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_AVERAGE_REQUEST });
      const { auth } = getState();
      let params = {
        customerId: auth?.user?.Customer_Id,
        companyId: auth.company?.id,
        finyearId: auth.finyear?.id,
        commonMaster: !!auth?.company?.Common_Master,
        machineId
    };
      return axios.get(`/worker-average/get-worker-avg-summary`, { params }).then((response) => {
        if (response.data) {
            dispatch({ type: SET_WORKER_AVERAGE_SUMMURY, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_AVERAGE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_AVERAGE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};